<ion-toolbar class="main-header-toolbar">
    <app-student-header></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->


    <ion-grid fixed class="page-grid no-margin-top student-grid student-page">


        <app-semi-header [title]="'headerComp.headerPopover.myCertificates'|transloco" [showAchievementInfo]="true" [withShadow]="showCertificatesDummy"></app-semi-header>


        <ion-row class=" ion-no-padding" *ngIf="!showCertificatesDummy">
            <ion-col size="12" class="ion-no-margin ion-no-padding">
                <app-tabs [styleGroup]="true" [studentStyle]="true" *ngIf="groupedByYear">

                    <app-tab [tabTitle]="year" [active]="activeTabs[year]" *ngFor="let year of uniqueYears">


                        <ion-row class="study-content ion-no-padding">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="certificate-wrapper">
                                    <app-certificate class="certificate" *ngFor="let group of groupedByYear[year]"
                                                     [group]="group"></app-certificate>

                                </div>

                            </ion-col>

                        </ion-row>
                    </app-tab>


                </app-tabs>


            </ion-col>


            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <app-banners [banners]=""></app-banners>
            </ion-col>


        </ion-row>


        <ion-row class="ion-no-padding dummy study-content" *ngIf="showCertificatesDummy">
            <ion-col size="12" class="ion-no-margin ion-no-padding white-col">

                <app-dummy [type]="'certificate'"></app-dummy>

<!--                <img src="/images/dummies/no_certificates.png" alt="not study history yet">-->
<!--                <img [src]="'assets/images/' + this.lang + '/dummies/no_certificates.png'" alt="not study history yet">-->
            </ion-col>
        </ion-row>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>

<app-chats></app-chats>
